import {
  H3,
  typography,
  Button as ButtonRaw,
  size,
  colors,
  Icons,
} from '@everlywell/leaves';
import styled from 'styled-components';

export const Title = styled(H3)`
  font-weight: ${typography.weight.regular};
  margin-bottom: ${size.lg}px;
  text-align: left;
`;

export const Description = styled.div`
  ${typography.bodyText}
  margin-bottom: ${size.lg}px;
  text-align: left;
`;

export const Address = styled.div`
  position: relative;
`;

export const SavedBlurb = styled.div`
  background: ${colors.green1};
  padding: ${size.xs1}px ${size.md}px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${size.xl1}px;
  border-radius: ${size.xs1}px;
  text-align: left;
`;

export const InfoIcon = styled.div`
  width: ${size.xl2}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled(Icons.InformationV2)`
  color: ${colors.green4};
  margin-right: ${size.sm}px;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  flex: 1;
  color: ${colors.gray5};
`;

export const Button = styled(ButtonRaw)``;
